module.exports = __webpack_public_path__ + "static/media/ICON-SOBRE3.a6e38e97.svg";